import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { InstanceTagField } from '@/components/forms/RunRiskCalibrationForm/fields/InstanceTagField'
import { PushToDbField } from '@/components/forms/RunRiskCalibrationForm/fields/PushToDbField'
import { ValueDateField } from '@/components/forms/RunRiskCalibrationForm/fields/ValueDateField'

export interface CalibrationFieldsProps {}

export const CalibrationFields: React.FC<CalibrationFieldsProps> = ({}) => {
  return (
    <FormFieldRow>
      <ValueDateField />
      <InstanceTagField />
      <PushToDbField />
    </FormFieldRow>
  )
}
